export const ON_SUCCESS_GET_EXPANSION_RULE = '@@searchQueryExpansion/ON_SUCCESS_GET_EXPANSION_RULE';
export const ON_FAILURE_GET_EXPANSION_RULE = '@@searchQueryExpansion/ON_FAILURE_GET_EXPANSION_RULE';
export const UPDATE_PAGE = '@@searchQueryExpansion/UPDATE_PAGE';
export const IS_LOADING = '@@searchQueryExpansion/IS_LOADING';
export const UPDATE_INPUT_TEXT = '@@searchQueryExpansion/UPDATE_INPUT_TEXT';
export const CLEAR_EXPANSION_LIST = '@@searchQueryExpansion/CLEAR_EXPANSION_LIST';



